import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "css/main.css";
import "css/style.css";

import { getInvoices } from "services/invoices_service";

function App() {
  const [invoiceList, setInvoiceList] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    async function getInvcs() {
      try {
        let invList = await getInvoices();
        setInvoiceList(invList);
      } catch (exception) {
        console.log("exception", exception);
      }
    }

    getInvcs();
  }, []);

  return (
    <div className="App">
      <section className="section">
        <div className="columns credencial-style">
          <div className="column exist">
          <h2 className="title is-5">Lista de faturas</h2>
            <div className="block">
              <table className="table is-striped is-hoverable is-fullwidth">
                <thead>
                  <tr>
                    <th>{t("invoice_num")}</th>
                    <th>{t("date")}</th>
                    <th>{t("value_no_vat")}</th>
                    <th>{t("vat")}</th>
                    <th>{t("total")}</th>
                  </tr>
                </thead>
                <tbody>
                  {invoiceList.map((el, index) => (
                    <tr key={index}>
                      <th>
                        <a rel="noreferrer" target="_blank" href={el.attributes?.file?.data?.attributes?.formats?.large?.url}>
                          <span className="icon has-text-info">
                            <i className="fas fa-arrow-circle-down"></i>
                          </span>
                          {el.attributes.invoiceNumber}
                        </a>
                      </th>
                      <td>{el.attributes.invoiceDate}</td>
                      <td>{el.attributes.total * 0.77}€</td>
                      <td>{el.attributes.total * 0.23}€</td>
                      <td>{el.attributes.total}€</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default App;
